<app-top-nav></app-top-nav>

<div class="main">
  <div class="wrapper">
    <div class="global-head-row">
      <div class="page-title">Empty Buildings</div>
    </div>
    <div class="scroll-wrapper">
      <p-table
        #dt
        [value]="tableData$() | async"
        [columns]="cols"
        id="empty-buildings-table"
        [scrollable]="true"
        [scrollHeight]="getScrollHeight()"
        [virtualScroll]="false"
        [paginator]="true"
        [rows]="15"
        [showCurrentPageReport]="true"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
        class="table">
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th *ngFor="let col of columns">
              <div class="status-flex">
                <div
                  class="horizontal-flex"
                  *ngIf="!checkSortIcon(col.field); else filterHeader"
                >
                  {{ col.header }}
                </div>
                <ng-template #filterHeader>
                  <div
                    class="horizontal-flex clickable"
                    [matMenuTriggerFor]="extendedFilter"
                    #menuTrigger="matMenuTrigger"
                  >
                    {{ col.header }}
                    <ng-container
                      *ngIf="{
                        direction: (getFieldSort$(col.field) | async)
                      } as sort"
                    >
                      <mat-icon
                        class="sortIcon {{
                          sort.direction == 1
                            ? 'sort-ascending'
                            : 'sort-descending'
                        }}"
                        *ngIf="sort.direction"
                        >straight</mat-icon
                      >
                    </ng-container>
                    <mat-icon class="material-icons-outlined sortIcon"
                      >filter_alt</mat-icon
                    >
                    <ng-container
                      *ngIf="getFieldFilters$(col.field) | async as filters"
                    >
                      <span *ngIf="filters" class="clear-header-filters"
                        >({{ filters.length }})</span
                      >
                    </ng-container>
                  </div>
                  <mat-menu
                    class="column-filter-menu"
                    #extendedFilter="matMenu"
                    [hasBackdrop]="true"
                  >
                    <app-column-filter
                      *ngIf="menuTrigger.menuOpen"
                      [values]="getFieldValues$(col.field) | async"
                      [template]="getFieldTemplate(col.field)"
                      [canSearch]="getFieldFilterSearch(col.field)"
                      [hasEmptyValue]="getFieldHasEmptyValue(col.field)"
                      [initialSelected]="getFieldFilters$(col.field) | async"
                      [initialSort]="getFieldSort$(col.field) | async"
                      [ignoredValues]="col.ignoredFilterValues"
                      (sort)="setSort(col.field, $event)"
                      (filter)="setFilter(col.field, $event)"
                      (closePopup)="menuTrigger.closeMenu()"
                    ></app-column-filter>
                  </mat-menu>
                </ng-template>
                <ng-container *ngIf="col.field == 'lockedAddresses'">
                  <button
                    class="clear-button"
                    mat-flat-button
                    color="warn"
                    (click)="clearAllFilter()"
                    *ngIf="extendedFilterActive$ | async"
                  >
                    clear all
                  </button>
                </ng-container>
              </div>
            </th>

          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-emptyBuilding>
          <tr pEditableRow="emptyBuilding">
            <td>{{emptyBuilding.lomKey == null ? emptyBuilding.id : emptyBuilding.lomKey.toString()}}</td>
            <td>{{emptyBuilding.area.city}}</td>
            <td>{{emptyBuilding.area.fiberHood}}</td>
            <td>{{emptyBuilding.area.block}}</td>
            <td>{{emptyBuilding.locked}}</td>
            <td>{{emptyBuilding.lockedAddresses?.join(", ")}}</td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>
